import React, { Fragment, useEffect } from 'react';
import Breadcrumbs from 'CommonElements/Breadcrumbs';
import DefaultContain from 'Component/DashboardQeza/Treatment';

const Treatment = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Fragment>
            <Breadcrumbs parent="Perawatan" title="Daftar Perawatan" />
            <DefaultContain />
        </Fragment>
    );
};
export default Treatment;